import { Customer, VerifyStrategyType } from '@ca/common/types'
import { useCallback } from 'react'

const getStrategy = (
  customer: Partial<Customer> | undefined
): VerifyStrategyType => {
  if (customer?.email) {
    return 'email'
  }
  if (customer?.mobile) {
    return 'phone'
  }
  return 'staff'
}

const useGetAuthStrategy = () => {
  return useCallback(
    (customer?: Partial<Customer>) => getStrategy(customer),
    []
  )
}

export default useGetAuthStrategy
